import {enableProdMode, provideZoneChangeDetection} from '@angular/core';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';

import {AppModule} from './app/app.module';
import {environment} from './environments/environment';
import * as Sentry from '@sentry/angular';

if (environment.production) {
  Sentry.init({
    dsn: environment.sentry_url,
    integrations: [],
  });

  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule, {applicationProviders: [provideZoneChangeDetection()]})
  .catch(err => console.error(err));
